import {
  imDeleteFromArrayById,
  imSetToArray,
  imSetToObj,
  imPush,
} from '@client/shared/utils/immutableUtils/immutableUtils';

export const ADMIN_REDUCER_KEY = 'adminReducer';

export const SET_ADMIN_ERROR = 'SET_ADMIN_ERROR';
export const LOAD_ADMINS = 'LOAD_ADMINS';
export const PUT_AND_HANDLE_ADMIN = 'PUT_AND_HANDLE_ADMIN';
export const DELETE_AND_HANDLE_ADMIN = 'DELETE_AND_HANDLE_ADMIN';
export const PUT_AND_HANDLE_ADMIN_IMAGE = 'PUT_AND_HANDLE_ADMIN_IMAGE';
export const POST_AND_HANDLE_ADMIN = 'POST_AND_HANDLE_ADMIN';

/* DEFAULT CAMPAIGN STATE */
let defaultState = {
  admins: [],
};

/* REDUCER */
export default function(state = defaultState, action = {}) {
  switch (action.type) {
    case LOAD_ADMINS: {
      return {
        ...state,
        admins: action.payload.admins,
        totalElements: action.payload.totalElements,
        totalPages: action.payload.totalPages,
        nextPage: action.payload.nextPage,
      };
    }
    case SET_ADMIN_ERROR: {
      return { ...state, errors: action.payload };
    }
    case PUT_AND_HANDLE_ADMIN: {
      return {
        ...state,
        admins: imSetToArray(state.admins, action.payload, 'id'),
      };
    }
    case DELETE_AND_HANDLE_ADMIN: {
      return {
        ...state,
        admins: imDeleteFromArrayById(state.admins, 'id', action.payload),
      };
    }
    case PUT_AND_HANDLE_ADMIN_IMAGE: {
      const { imageUrl, adminId } = action.payload;
      const { admins } = state;

      const admin = admins.find((admin) => admin.id === adminId);
      const updatedAdmin = imSetToObj(admin, 'imageUrl', imageUrl);
      return {
        ...state,
        admins: imSetToArray(admins, updatedAdmin, 'id'),
      };
    }
    case POST_AND_HANDLE_ADMIN: {
      return {
        ...state,
        admins: imPush(state.admins, action.payload),
      };
    }
    default:
      return state;
  }
}
